import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function padDatetimePart(value: number): string {
  return String(value).padStart(2, '0');
}

export function formatInstantForLocalDatetimeInput(date: Date | string | number): string {
  const instant = new Date(date);
  if (isNaN(instant.getTime())) return "";

  const year = instant.getFullYear();
  const month = padDatetimePart(instant.getMonth() + 1);
  const day = padDatetimePart(instant.getDate());
  const hours = padDatetimePart(instant.getHours());
  const minutes = padDatetimePart(instant.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function localDatetimeInputToUtcIso(value: string): string {
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (!match) return "";

  const [, year, month, day, hours, minutes] = match;
  const localDate = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes)
  );

  if (isNaN(localDate.getTime())) return "";

  return localDate.toISOString();
}

export function nowAsLocalDatetimeInput(): string {
  return formatInstantForLocalDatetimeInput(new Date());
}
